module.exports = __webpack_public_path__ + "img/1557393958.df99322c.jpg";